import React from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

export type TitleSize = 'xs' | 'sm' | 'md' | 'lg';

const titleTypography: Record<TitleSize, string> = {
  xs: 'headingXs',
  sm: 'headingSm',
  md: 'headingMd',
  lg: 'headingLg',
};

export const Title = ({
  className,
  children,
  isNoMargin = false,
  isCenter = false,
  size = 'md',
  headingType,
}: TitleProps) => {
  return (
    <Box
      component={headingType || 'div'}
      className={className}
      sx={{
        typography: titleTypography[size],
        color: '#003413',
        ...(!isNoMargin && { mb: '36px' }),
        ...(isCenter && { textAlign: 'center' }),
      }}
    >
      {children}
    </Box>
  );
};

export interface TitleProps {
  className?: string;
  children: React.ReactNode;
  isNoMargin?: boolean;
  isCenter?: boolean;
  size?: TitleSize;
  headingType?: 'h1' | 'h2';
}

Title.displayName = 'Title';

export default Title;
